// 
export const BOOKINGREQUEST_LIST = 'BOOKINGREQUEST_LIST';
export const BOOKINGREQUEST_PAGINATION = 'BOOKINGREQUEST_PAGINATION';
export const BOOKINGREQUEST_SUMMARY = 'BOOKINGREQUEST_SUMMARY';